import React from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";


const MerchantSingle = ({merchant}) => (
    <div className="merchant-list-item">
        <Link to={ "/merchant/" + merchant.id }>
        <div className="merchant-card">
            <img className="merchant-logo" src={merchant.image_logo.url} />
            <div className="merchant-info-wrapper">
                <div className="merchant-name">{merchant.name}</div>
                <div className="merchant-street">{merchant.street}</div>
                <div className="merchant-dist-rewards-wrapper">
                    <div className="rewards-awailable">{merchant.discounts.length} Rewards Available</div>
                    <div className="divider"></div>
                    <div className="rewards-awailable">2.5 Miles</div>
                </div>
            </div>
        </div>
        </Link>  
    </div>
);




export default MerchantSingle;


// WEBPACK FOOTER //
// ./src/components/MerchantSingle/MerchantSingle.js